import dynamicMenus from "@/dynamic/menus";
const MENU = [
  ...dynamicMenus,
];

export default MENU;
